import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

export default function Shimmer({ type = "card" }) {
  if (type === "card") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        <Skeleton
          variant="rectangular"
          width={60}
          height={60}
          sx={{ borderRadius: 2, marginRight: 2 }}
        />
        <Box sx={{ width: "100%" }}>
          <Skeleton variant="text" width="60%" height={30} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Box>
    );
  }
  if (type === "text") {
    return <Skeleton variant="text" width="100%" />;
  }
  if (type === "rect") {
    return <Skeleton variant="rectangular" width="100%" height={118} />;
  }
  return <Skeleton variant="rectangular" width={210} height={118} />;
}
